import React, { Component } from 'react';
import './style.css';

export default class PCover extends Component {
  render() {
    const { project } = this.props;

    return (
      <div className='main' id='head'>
        {/* <img
          className="pCover"
          src={project.cover}
          width="100%"
          height="1000vh"
        /> */}
        <div className=' container coverCont'>
          <div className='row coverImg'>
            <img src={project.cover} alt='' className='projectCover' />
          </div>
          <div className='pLogoCont'>
            <div className='row'>
              <div className='col-lg-2 col-md-3 col-12 logoCont'>
                <img className='pLogo' src={project.logo} />
              </div>
              <div className='appHeaderDataCont col-md-10 col-sm-12 col-12'>
                <div className='row'>
                  <div className='appMetaCont col-md-7 col-sm-12 col-12'>
                    <p className='pName'>{project.name}</p>
                    <p className='pDesc'>{project.desc}</p>
                  </div>
                  <div className='actionsCont col-md-5 col-sm-12 col-12'>
                    {project.iosStore ? (
                      <a href={project.iosStore} target='_blank'>
                        <img
                          src='https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Icons%2FappStoreIcon.png?alt=media&token=d95ec654-59e8-4851-8335-b89c08c7d8a9'
                          alt=''
                          className='storeIcon'
                        />
                      </a>
                    ) : null}
                    {project.playURL ? (
                      <a href={project.playURL} target='_blank'>
                        <img
                          src='https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Icons%2FgooglePlay.jpeg?alt=media&token=0828b5f5-02d3-4dbc-b0aa-08d47fc85a34'
                          alt=''
                          className='storeIcon'
                        />
                      </a>
                    ) : null}

                    {project.webURL ? (
                      <a href={project.webURL} target='_blank'>
                        <img
                          src='https://firebasestorage.googleapis.com/v0/b/my-portfolio-60b5a.appspot.com/o/Icons%2Fweb.png?alt=media&token=582dcf70-ece7-4885-8d8c-39ac654afed8'
                          alt=''
                          className='storeIcon'
                        />
                      </a>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
